import { Injectable } from '@angular/core';

import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private storageInstance: Storage | null = null;
  private inited: Promise<void>;

  constructor(private storage: Storage) {
    this.inited = this.init();
  }

  private async init() {
    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
    this.storageInstance = await this.storage.create();
  }

  public async set(key: string, value: any): Promise<any> {
    await this.inited;
    return this.storageInstance?.set(key, value);
  }

  public async get(key: string): Promise<any> {
    await this.inited;
    return this.storageInstance?.get(key);
  }

  public async remove(key: string): Promise<any> {
    await this.inited;
    return this.storageInstance?.remove(key);
  }

  public async list(): Promise<string[]> {
    await this.inited;
    return this.storageInstance?.keys() ?? Promise.resolve([]);
  }
}
